// extracted by mini-css-extract-plugin
export default {"div":"Services_div__T0YFR","bgImg":"Services_bgImg__TS64w","content":"Services_content__kvnSr","image":"Services_image__3aNTp","info":"Services_info__W2KqZ"};